/**
 * The service pages. A34.
 *
 * Two small behaviours, both with a working fallback: the ring-size tabs
 * (without this, all three panels are simply shown) and the care request's
 * photograph guidance, which appears when the piece was not bought online.
 */

const tabs = document.querySelector('[data-tabs]');
if (tabs) {
  tabs.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-tab]');
    if (!tab) return;
    const which = tab.dataset.tab;
    tabs.querySelectorAll('[data-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    tabs.querySelectorAll('[data-panel]').forEach((p) => (p.hidden = p.dataset.panel !== which));
  });
}

const request = document.querySelector('#care-request');
if (request) {
  const photo = request.querySelector('[data-photo]');
  request.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="contact[piece]"]') || !photo) return;
    photo.hidden = !event.target.hasAttribute('data-reveal-photo');
  });
}
